import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { getPrayerTimesState } from "../../Redux/GetState";
import AnalogueClock from "./Helper/AnalogueClock";
import { IAnalogProps } from "./IAnalogProps";

export const Clock: React.FC<IAnalogProps> = (
  props: IAnalogProps
): JSX.Element => {
  const [dateTime, setDateTime] = useState(new Date());
  const [dataError, setDataError] = useState(false);

  const { apiError } = useSelector(getPrayerTimesState);

  function determineNotchColor() {
    setDataError(apiError);
  }

  useEffect(() => {
    setDateTime(props.dateTime);
  }, [props.dateTime]); // <-- here put the parameter to listen

  useEffect(() => {
    determineNotchColor();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiError]); // <-- here put the parameter to listen

  const clockOptions = {
    baseColor: "##131313;",
    borderColor: "#131313",
    borderWidth: 0,
    centerColor: "#ff1e00",
    handColors: {
      hour: "#ffffff",
      minute: "#ffffff",
      second: "#ff1e00",
    },
    notchColor: dataError ? "#ff002f" : "#00ff37",
    numbersColor: "#ffffff",
    showNumbers: true,
    size: props.size,
    dateTime: dateTime,
  };

  return (
    <div className="body-center">
      <AnalogueClock {...clockOptions} />
    </div>
  );
};
